<template>
  <b-row class="filters-row">
    <b-col cols="12" md="3" class="mb-1 mb-md-0">
      <v-select
        :value="templateFilter"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="templateOptions"
        class="w-100"
        label="name"
        :reduce="(val) => val.id"
        :placeholder="$tc('risk.template.title')"
        :clearable="true"
        @input="(val) => $emit('update:templateFilter', val)"
      >
        <template #no-options>
          {{ $t('no_options_available') }}
        </template>
      </v-select>
    </b-col>
    <b-col cols="12" md="3" class="mb-1 mb-md-0">
      <v-select
        :value="unitFilter"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="unitOptions"
        class="w-100"
        label="label"
        :reduce="(val) => val.value"
        :placeholder="$tc('unit.title')"
        :clearable="true"
        @input="(val) => $emit('update:unitFilter', val)"
      >
        <template #no-options>
          {{ $t('no_options_available') }}
        </template>
      </v-select>
    </b-col>
    <b-col cols="12" md="3" class="mb-1 mb-md-0">
      <v-select
        :value="userFilter"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="userOptions"
        class="w-100"
        label="label"
        :reduce="(val) => val.value"
        :placeholder="$tc('users.title')"
        :clearable="true"
        @input="(val) => $emit('update:userFilter', val)"
      >
        <template #no-options>
          {{ $t('no_options_available') }}
        </template>
      </v-select>
    </b-col>
    <b-col cols="12" md="3" class="mb-1 mb-md-0">
      <v-select
        :value="statusFilter"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :options="statusOptions"
        class="w-100"
        label="label"
        :reduce="(val) => val.value"
        :placeholder="$tc('status')"
        :clearable="true"
        @input="(val) => $emit('update:statusFilter', val)"
      >
        <template #no-options>
          {{ $t('no_options_available') }}
        </template>
      </v-select>
    </b-col>
  </b-row>
</template>

<script>
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";


export default {
  name: "FiltersRow",
  components: {
    vSelect,
  },
  props: {
    templateOptions: {
      type: Array,
      default: () => []
    },
    templateFilter: {
      type: Number,
      default: null
    },
    unitOptions: {
      type: Array,
      default: () => []
    },
    unitFilter: {
      type: [Number, String],
      default: null
    },
    userOptions: {
      type: Array,
      default: () => []
    },
    userFilter: {
      type: [Number, String],
      default: null
    },
    statusOptions: {
      type: Array,
      default: () => []
    },
    statusFilter: {
      type: [Number, String],
      default: null
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";

.filters-row {
  .vs__selected {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block !important;
  }

  .vs__dropdown-option {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .vs__selected-options {
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .v-select {
    &.vs--open {
      .vs__dropdown-toggle {
        border-color: #7367f0 !important;
      }
    }
  }

  .vs__clear {
    margin-right: 4px;
  }

  .vs__dropdown-menu {
    max-height: 250px;
  }
}
</style>
